module.exports = __webpack_public_path__ + "img/icon-form-field-toggle.3494b1b2.svg";